Optionally filter results to only include position openings with the specified status code.

Currently, three codes are defined:

- `Incomplete` indicates the position opening is in a draft state.
- `Active` indicates the position opening is open.
- `Closed` indicates the position opening has been closed.
